import React from 'react'
import ReactDOM from 'react-dom/client'
import { App, AppFailure } from './App'
import '#styles/index.css'
import { loadInitialUserData } from '#app/store/middlewares/userDataPersistence'
import { lateInitializeStore } from '#app/store/root'
import { initializeUserManager } from '#features/User/userManager'
import { makeI18n } from '#i18n/i18n'
import { namespaces, resources } from './i18n/resources/resources'

const root = document.getElementById('root')
if (root === null) {
  throw new Error('No root element found')
}

if (VITE_BUILD_WITHOUT_STRICT) {
  console.warn('Strict mode has been disabled.')
}

async function setup(root: HTMLElement) {
  const resolve = await Promise.allSettled([
    makeI18n(namespaces, { kind: 'dynamic', resources: resources }),
    initializeUserManager(),
    lateInitializeStore(),
  ])
  // don't mind that it takes some time to resolve
  void loadInitialUserData()

  const anyError = resolve.some((x) => x.status === 'rejected')

  if (anyError) {
    ReactDOM.createRoot(root).render(<AppFailure />)
    return
  }
  ReactDOM.createRoot(root).render(
    VITE_BUILD_WITHOUT_STRICT ? (
      <App />
    ) : (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    ),
  )

  // asynchronously to reduce initial load time
  void import('./utils/registerDebug.ts')
}

void setup(root)
